import { render, staticRenderFns } from "./simOpenZb.vue?vue&type=template&id=676cd014&scoped=true&"
import script from "./simOpenZb.vue?vue&type=script&lang=js&"
export * from "./simOpenZb.vue?vue&type=script&lang=js&"
import style0 from "./simOpenZb.vue?vue&type=style&index=0&id=676cd014&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676cd014",
  null
  
)

export default component.exports